// extracted by mini-css-extract-plugin
module.exports = {"SeriesTitle":"SeriesTitle_SeriesTitle__wp0cI","Controls":"SeriesTitle_Controls__24_uo","AddToCart":"SeriesTitle_AddToCart__1EONx"};